// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stopLabel_label_p0Ekx {
  padding: 10px 7px 7px 10px;
  margin: 5px;
  white-space: nowrap;
  color: black;
  background: hsla(0, 0%, 100%, 0.8);
}

.stopLabel_title_qBaY7 {
  font-size: 16px;
  font-family: GothamRounded-Medium;
  line-height: 16px;
}

.stopLabel_subtitle_eFRp9 {
  font-size: 16px;
  font-family: GothamRounded-Book;
}

.stopLabel_content_VHnn4 {
  font-size: 15px;
  line-height: 16px;
  padding: 5px 0 0;
}

.stopLabel_route_iECWL {
  font-family: GothamXNarrow-Medium;
}

.stopLabel_destination_roDH4 {
  font-family: GothamRounded-Medium;
}

.stopLabel_destinationLight_g8C60 {
  font-family: GothamRounded-Book;
}

.stopLabel_flexContainer_Iz6rN {
  display: flex;
  flex-direction: row;
  justify-content: left;
}

.stopLabel_destinationContainer_CIFTL {
  align-self: center;
}

.stopLabel_comma_ldwMG {
  margin-right: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/map/stopLabel.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".label {\n  padding: 10px 7px 7px 10px;\n  margin: 5px;\n  white-space: nowrap;\n  color: black;\n  background: hsla(0, 0%, 100%, 0.8);\n}\n\n.title {\n  font-size: 16px;\n  font-family: GothamRounded-Medium;\n  line-height: 16px;\n}\n\n.subtitle {\n  font-size: 16px;\n  font-family: GothamRounded-Book;\n}\n\n.content {\n  font-size: 15px;\n  line-height: 16px;\n  padding: 5px 0 0;\n}\n\n.route {\n  font-family: GothamXNarrow-Medium;\n}\n\n.destination {\n  font-family: GothamRounded-Medium;\n}\n\n.destinationLight {\n  font-family: GothamRounded-Book;\n}\n\n.flexContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: left;\n}\n\n.destinationContainer {\n  align-self: center;\n}\n\n.comma {\n  margin-right: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `stopLabel_label_p0Ekx`,
	"title": `stopLabel_title_qBaY7`,
	"subtitle": `stopLabel_subtitle_eFRp9`,
	"content": `stopLabel_content_VHnn4`,
	"route": `stopLabel_route_iECWL`,
	"destination": `stopLabel_destination_roDH4`,
	"destinationLight": `stopLabel_destinationLight_g8C60`,
	"flexContainer": `stopLabel_flexContainer_Iz6rN`,
	"destinationContainer": `stopLabel_destinationContainer_CIFTL`,
	"comma": `stopLabel_comma_ldwMG`
};
module.exports = ___CSS_LOADER_EXPORT___;
